// F9 (fase 2, corte 8, ticket #0747) — la entrega programada.
//
//   PUT /assets/:id/entrega → fija o cambia el día y la hora de inicio de
//   la entrega de la unidad (`assets.attributes.fecha_entrega`, ADR-0144).
//
// Lo hacen el jefe (en sus proyectos) y el gerente (en la org): el carril
// `assigning_party` de la receta, con el alcance del dashboard. Errores:
//   - 409 `DELIVERY_NOT_ENABLED`: la receta no tiene contraparte EXTERNA
//     (facility); va antes de mirar ninguna fila;
//   - 403 `DELIVERY_ACTOR_NOT_ALLOWED`: otro rol (pasan el carril
//     `assigning_party` y `admin`, el personal interno);
//   - 400 `DELIVERY_DATE_OUT_OF_RANGE`: un día pasado o a más de
//     `UNIT_DELIVERY_MAX_DAYS_AHEAD` días;
//   - 403 `ASSET_OUT_OF_SCOPE`: la unidad no existe o está fuera del
//     alcance del que llama (un solo código para las dos cosas: sin
//     oráculo de existencia);
//   - 409 `DELIVERY_ALREADY_HAPPENED`: la entrega guardada ya ocurrió
//     (la unidad está entregada); va después de la contención.
// Exige Idempotency-Key (scope org + unidad). El mismo día y la misma hora
// que la vigente = `changed: false`: nada se escribe, nada se avisa.
//
// El aviso (campana + correo) va sólo al propietario CON CUENTA
// (`assets.owner_user_id`); separar invitar de activar es de la fase 3.
import { isCalendarDate, isDeliveryTime, santiagoDate, visitTimeLabel, } from "@bitacorapro/core-engine";
import { z } from "zod";
import { visitaDiaLabel } from "./observation-labels.js";
import { ownerNoticeOutcomeSchema } from "./owner-notifications.js";
export const DELIVERY_NOT_ENABLED = "DELIVERY_NOT_ENABLED";
export const DELIVERY_ACTOR_NOT_ALLOWED = "DELIVERY_ACTOR_NOT_ALLOWED";
export const DELIVERY_DATE_OUT_OF_RANGE = "DELIVERY_DATE_OUT_OF_RANGE";
export const DELIVERY_ALREADY_HAPPENED = "DELIVERY_ALREADY_HAPPENED";
/** El día de la entrega en el wire: «AAAA-MM-DD» de Santiago. */
export const unitDeliveryDateSchema = z
    .string()
    .refine(isCalendarDate, { message: "date must be a calendar day (YYYY-MM-DD)" });
/** La hora de inicio: «HH:MM» de pared de Santiago, en pasos de 30 min. */
export const unitDeliveryTimeSchema = z
    .string()
    .refine(isDeliveryTime, { message: "time must be HH:MM in 30-minute steps" });
export const unitDeliveryBody = z
    .object({ date: unitDeliveryDateSchema, time: unitDeliveryTimeSchema })
    .strict();
/** La entrega leída de la ficha, en hora de pared de Santiago. `time`
 *  null cuando la planilla sólo trajo el día. */
export const unitDeliveryWireSchema = z.object({
    date: z.string(),
    time: z.string().nullable(),
});
export const unitDeliveryResponse = z.object({
    id: z.string().uuid(),
    entrega: unitDeliveryWireSchema,
    /** False cuando el día y la hora ya eran los vigentes. */
    changed: z.boolean(),
    /** ¿La unidad tiene un propietario con cuenta? Sin él no se avisa a
     *  nadie (la fecha queda guardada igual). */
    ownerHasAccount: z.boolean(),
    /** Qué pasó con el correo al propietario (ADR-0147). Ausente sin cambio
     *  o sin propietario con cuenta. */
    ownerNotice: ownerNoticeOutcomeSchema.optional(),
});
/** «miércoles 28-oct, 10:00» (o sólo el día si no hay hora), en
 *  minúscula: va dentro de una frase. Mismo formato que la visita. Con
 *  `now`, un día de otro año que el actual (en Santiago) lleva el año
 *  («viernes 20-jun-2025»): en una tabla, una entrega del año pasado no
 *  puede verse igual que una que viene. */
export function entregaLabel(e, now) {
    const base = visitaDiaLabel(e.date);
    const year = e.date.slice(0, 4);
    const dia = now && year !== santiagoDate(now).slice(0, 4) ? `${base}-${year}` : base;
    return e.time ? `${dia}, ${visitTimeLabel(e.time)}` : dia;
}
//# sourceMappingURL=unit-delivery.js.map